<template>
  <div id="about_us">
    <van-row>
      <van-col span="24">
        <van-col span="24">
          <van-nav-bar
              left-arrow
              placeholder
              :title="$t('title.about_us')"
              safe-area-inset-top
              @click-left="onClickLeft"
          />
        </van-col>
      </van-col>
      <van-col span="24">
        <van-col span="24" class="about_us_list_logo">
          <img :src="logo"/>
        </van-col>
        <van-col span="20" offset="2" class="about_us_list_name"> {{ version }}({{ init_version }}) </van-col>
        <van-list>
          <van-cell v-for="(item,i) in list" :key="i" class="about_us_list_cell" is-link @click="article_btn(item)">
            <template #title>
              <div class="about_us_list_title">{{ item.title }}</div>
            </template>
          </van-cell>

        </van-list>
      </van-col>
      <van-popup v-model="article_show" round closeable style="maxHeight: 70%;width: 90%;padding-bottom: 5vw;">
        <van-col span="18" offset="3" class="about_us_popup_name"> {{ article.title }}</van-col>
        <van-col span="22" offset="1" class="about_us_popup_content" v-html="article.content"></van-col>
      </van-popup>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Dialog, Toast} from "vant";
import {judgeIosAndroid} from "../assets/js/models";

export default {
  data() {
    return {
      article_show: false,
      version: 'Current Versian:1.1.0',
      init_version: undefined,
      list: [],
      logo: undefined,
      article: {
        id: undefined,
        title: undefined,
        content: undefined
      },
    }
  },
  created () {
    this.convert()
  },
  methods: {
    article_btn(item){
      this.article = item
      this.article_show = true
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    convert() {
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=about_us", {
        params : {
          token: token
        }
      }).then(res =>{
        // 加载状态结束
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.list = res.data.data.list
        this.logo = res.data.data.app_logo
        this.init_version = res.data.data.init_version
      })
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/about_us.vue